import React, { useState, useEffect } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import style from "./ContactUsForm.module.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact_number: "",
    address: "",
    approx_budget: "",
    event_days: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [error, setError] = useState(null);
  const [flash, setFlash] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);
  const [showSubmittedOverlay, setShowSubmittedOverlay] = useState(false);

  useEffect(() => {
    setFlash(true);
    setTimeout(() => setFlash(false), 300);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Allow users to type freely
    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === "approx_budget" && value !== "") {
      const numericValue = parseInt(value, 10);
      if (numericValue < 35000) {
        setFormData({ ...formData, [name]: "35000" });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResponseMessage("");

    if (!formData.approx_budget || parseInt(formData.approx_budget, 10) < 35000) {
      setError("Minimum budget should be ₹35,000 or more.");
      return;
    }

    try {
      const response = await axios.post(
        "https://studiomaamangala.com/wp-json/custom/v1/contact",
        formData
      );

      setFlash(true);
      setTimeout(() => {
        setFlash(false);
        setTimeout(() => setFlash(true), 100);
        setTimeout(() => setFlash(false), 400);
      }, 300);

      setSubmittedData(formData);
      setResponseMessage(response.data.message);

      setFormData({
        name: "",
        email: "",
        contact_number: "",
        address: "",
        approx_budget: "",
        event_days: "",
      });

      setShowSubmittedOverlay(true);
      setTimeout(() => {
        setShowSubmittedOverlay(false);
      }, 2000);
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message || "Something went wrong.");
      } else {
        setError("Unable to connect to the server.");
      }
    }
  };

  return (
    <motion.div
      className={style.formContainer}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      id="contactForm"
    >
      <AnimatePresence>
        {flash && (
          <motion.div
            className={style.flashEffect}
            initial={{ opacity: 1 }}
            animate={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          />
        )}
      </AnimatePresence>

      <div className={style.contentWrapper}>
        <motion.form
          className={style.contactForm}
          onSubmit={handleSubmit}
          initial={{ scale: 1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className={style.header}>
            <div className={style.headerLeft}>
              <div className={style.connectButton}>CONNECT</div>
            </div>
            <div className={style.headerRight}>
              <button type="submit" className={style.captureButton}>
                SUBMIT
              </button>
            </div>
          </div>

          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter Your Name"
            required
            className={style.inputField}
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter Your Email"
            required
            className={style.inputField}
          />
          <input
            type="text"
            name="contact_number"
            value={formData.contact_number}
            onChange={handleChange}
            placeholder="Enter Your Number"
            required
            className={style.inputField}
          />
          <input
            type="number"
            name="approx_budget"
            value={formData.approx_budget}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Enter Your Approximate Budget"
            required
            className={style.inputField}
          />
          <p className={style.disclaimer}>
            * Minimum budget should be ₹35,000 or more.
          </p>

          <input
            type="text"
            name="event_days"
            value={formData.event_days}
            onChange={handleChange}
            placeholder="Event Days"
            required
            className={style.inputField}
          />
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter Address"
            required
            className={style.textArea}
          ></textarea>
        </motion.form>

        <div className={style.rightContent}>
          {submittedData ? (
            <div className={style.submittedInfo}>
              <h6>Thank You</h6>
              <p>
                <strong>Hi,</strong> {submittedData.name}, we captured your
                details.
              </p>
            </div>
          ) : (
            <p className={style.defaultMessage}>
              Please fill out the form to see the submission details here.
            </p>
          )}
        </div>
      </div>

      <AnimatePresence>
        {showSubmittedOverlay && (
          <motion.div
            className={style.submittedOverlay}
            initial={{ clipPath: "circle(0% at 50% 50%)" }}
            animate={{ clipPath: "circle(100% at 50% 50%)" }}
            exit={{ clipPath: "circle(0% at 50% 50%)" }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
          >
            <div className={style.submittedInfo}>
              <h6>Thank You</h6>
              <p>
                <strong>Hi,</strong> {submittedData?.name}, we captured your
                details.
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {error && <p className={style.errorMessage}>{error}</p>}
      {console.log(responseMessage)}
    </motion.div>
  );
};

export default ContactForm;
